var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("SubcategoriesController", [
    "$scope", "$rootScope", "$window", "elasticService", "configs", "commonService",
    function ($scope, $rootScope, $window, elasticService, configs, commonService) {
        //#region  initialize functions
        $scope.initialize = function(){
            $rootScope.showLoader = true;
            if (angular.isDefined($window.category)) {
                $scope.category = $window.category.replace(/-/g,' ');
            }
            if (angular.isDefined($window.prdDefinition)) {
                $scope.prdDef = $window.prdDefinition;
            }
            if (angular.isDefined($window.freeProducts)) {
                $scope.freeProducts = ($window.freeProducts.toLowerCase() === 'true');
            }
            if($scope.prdDef.toLowerCase() =='stockdesign'){
                $scope.displayPrdType = $scope.freeProducts ? $rootScope.localeVariables.freeDesigns:$rootScope.localeVariables.designs;
            }
            else if($scope.prdDef.toLowerCase() =='font'){
                $scope.displayPrdType =  $rootScope.localeVariables.fonts;
            }
            else{
                $scope.displayPrdType = prdDef;
            }
            getEmbroidersPicks();
        }
        //#endregion

        //#region Embroiderers picks
        function getEmbroidersPicks(){
            commonService.getElasticData(
                configs.elasticBaseUrl,
                elasticService.buildCategorySamplesRequest($scope.prdDef, $scope.category,$scope.freeProducts)
            ).then(
                function(response){
                    if(response && response.data && response.data.hits && response.data.hits.hits){
                        $scope.embroidersPicks = response.data.hits.hits;
                        getSubCategoriesUrl($scope.category);
                        $rootScope.showLoader = false;
                    }
                }
            );
        }
        //#endregion

        //#region Category Page Url
        function getSubCategoriesUrl (category){
            var pageUrl="";
            pageUrl += '/themes';
            pageUrl += ($scope.freeProducts ? '/free-embroidery-designs/' : '/designs/');
            pageUrl += category.replace(/ /g, "-")+'/'+category.replace(/ /g, "-");
            $scope.pageUrl=pageUrl;
        }
        //#endregion
    }
]);
